const baseUrl = 'lifestyle_generations';

export class LifestyleGenerationsBffUrl {
  static create() {
    return baseUrl;
  }

  static show(id: string) {
    return `${baseUrl}/${id}`;
  }
}
